import React, { Suspense, useRef, useState, useEffect } from "react"
import { Canvas, useFrame, useLoader } from "@react-three/fiber"
import { ContactShadows, Environment, useGLTF, OrbitControls, PerspectiveCamera } from "@react-three/drei"
import { VRCanvas, useXR, Hands,DefaultXRControllers } from '@react-three/xr'
import { Vector3 } from 'three'
import { Stars } from './StarsVR'

import Room from './Room'



function Player(props) {
  const { player, isPresenting } = useXR()

  useEffect(() => {
    if (isPresenting) {
      player.position.set(0, 0, -4)
      player.rotation.set(0, Math.PI, 0)
    } else {
      player.position.set(0, 0, 0)
      player.rotation.set(0, 0, 0)
    }
  }, [isPresenting])

  return (
    <>
    </>
  )
}

export default function App() {


  return (
    <>
      <VRCanvas dpr={[1, 1.5]} camera={{ position: [0, 1.3, -4], fov: 50 }}>
        <Stars />
        <Hands />
        <DefaultXRControllers />
        <Player />
        <ambientLight intensity={0.1} />
        <pointLight intensity={10} angle={0.1} penumbra={1} position={[0, 6, 0]} castShadow />
        <Suspense fallback={null}>

          <Room />
          {/* <Environment path="" files="potsdamer_platz_1k.hdr" /> */}
          {/* <ContactShadows rotation-x={Math.PI / 2} position={[0, -0.8, 0]} opacity={0.25} width={10} height={10} blur={1.5} far={0.8} /> */}
        </Suspense>
        <OrbitControls enableZoom={true} enablePan={false} target={[0, 1.0, 0]} />
      </VRCanvas>
    </>
  )
}
